var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useRef, useState } from 'react';
export const usePlainText = () => {
    const formRef = useRef(null);
    const [showPlainText, setShowPlainText] = useState(false);
    const getPlainText = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setShowPlainText(true);
        yield new Promise(requestAnimationFrame);
        if (!formRef.current)
            return '';
        const range = document.createRange();
        range.selectNodeContents(formRef.current);
        const selection = window.getSelection();
        if (!selection)
            return '';
        selection.removeAllRanges();
        selection.addRange(range);
        const text = selection.toString();
        setShowPlainText(false);
        return text;
    }), []);
    return { formRef, showPlainText, setShowPlainText, getPlainText };
};
export const useSaveTemplateText = ($block, getPlainText, isDisabled) => {
    useEffect(() => {
        if ($block.isLocked || isDisabled)
            return;
        const checkAndSaveTemplateText = () => __awaiter(void 0, void 0, void 0, function* () {
            const plainText = yield getPlainText();
            if (plainText && $block.data.text !== plainText) {
                yield $block.saveText({ text: plainText });
            }
        });
        checkAndSaveTemplateText();
    }, [$block.data.text, $block.data.payload, getPlainText, $block.isLocked]);
};
